import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createOAuthAppRequest = { oAuthApp: '_oAuthApp' };
var _createOAuthAppResponse = { oAuthApp: '_oAuthApp' };
var _deleteOAuthAppRequest = {};
var _deleteOAuthAppResponse = {};
var _generateOAuthAppSecretRequest = {};
var _generateOAuthAppSecretResponse = {};
var _getOAuthAppRequest = {};
var _getOAuthAppResponse = { oAuthApp: '_oAuthApp' };
var _oAuthApp = { createdDate: 'google.protobuf.Timestamp' };
var _queryOAuthAppsRequest = {};
var _queryOAuthAppsResponse = { oAuthApps: '_oAuthApp' };
var _updateOAuthAppRequest = {
    mask: 'google.protobuf.FieldMask',
    oAuthApp: '_oAuthApp',
};
var _updateOAuthAppResponse = { oAuthApp: '_oAuthApp' };
function resolveWixHeadlessV1OAuthAppServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/oauth-app-service',
                destPath: '',
            },
            {
                srcPath: '/oauth-app',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/oauth-app',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/oauth-app-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new OAuth app for a Wix Headless client. */
export function createOAuthApp(payload) {
    var _a = serializer(_createOAuthAppRequest, { _oAuthApp: _oAuthApp }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOAuthAppResponse, {
        _oAuthApp: _oAuthApp,
    }).fromJSON;
    function __createOAuthApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.headless.v1.o_auth_app',
            method: 'POST',
            methodFqn: 'wix.headless.v1.OAuthAppService.CreateOAuthApp',
            url: resolveWixHeadlessV1OAuthAppServiceUrl({
                protoPath: '/v1/oauth-apps',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOAuthApp.fromReq = fromReq;
    __createOAuthApp.__isAmbassador = true;
    return __createOAuthApp;
}
/** Retrieves an OAuth app by ID. */
export function getOAuthApp(payload) {
    var _a = serializer(_getOAuthAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOAuthAppResponse, { _oAuthApp: _oAuthApp }).fromJSON;
    function __getOAuthApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.headless.v1.o_auth_app',
            method: 'GET',
            methodFqn: 'wix.headless.v1.OAuthAppService.GetOAuthApp',
            url: resolveWixHeadlessV1OAuthAppServiceUrl({
                protoPath: '/v1/oauth-apps/{oAuthAppId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOAuthApp.fromReq = fromReq;
    __getOAuthApp.__isAmbassador = true;
    return __getOAuthApp;
}
/**
 * Updates an OAuth app.
 *
 *
 * Only fields provided in `mask.paths` are updated.
 *
 * You can update the following fields:
 * + `name`
 * + `description`
 * + `allowedDomain`
 * + `loginUrl`
 * + `logoutUrl`
 * + `technology`
 */
export function updateOAuthApp(payload) {
    var _a = serializer(_updateOAuthAppRequest, { _oAuthApp: _oAuthApp }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOAuthAppResponse, {
        _oAuthApp: _oAuthApp,
    }).fromJSON;
    function __updateOAuthApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.headless.v1.o_auth_app',
            method: 'PATCH',
            methodFqn: 'wix.headless.v1.OAuthAppService.UpdateOAuthApp',
            url: resolveWixHeadlessV1OAuthAppServiceUrl({
                protoPath: '/v1/oauth-apps/{oAuthApp.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOAuthApp.fromReq = fromReq;
    __updateOAuthApp.__isAmbassador = true;
    return __updateOAuthApp;
}
/**
 * Deletes an OAuth app by ID.
 *
 *
 * > **Note:** After you delete an OAuth app, an external client can no longer make API calls by authenticating with its client ID.
 */
export function deleteOAuthApp(payload) {
    var _a = serializer(_deleteOAuthAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteOAuthAppResponse, {}).fromJSON;
    function __deleteOAuthApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.headless.v1.o_auth_app',
            method: 'DELETE',
            methodFqn: 'wix.headless.v1.OAuthAppService.DeleteOAuthApp',
            url: resolveWixHeadlessV1OAuthAppServiceUrl({
                protoPath: '/v1/oauth-apps/{oAuthAppId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteOAuthApp.fromReq = fromReq;
    __deleteOAuthApp.__isAmbassador = true;
    return __deleteOAuthApp;
}
/**
 * Retrieves a list of OAuth apps, given the provided paging, filtering, and sorting.
 *
 *
 * Query OAuth Apps runs with these defaults, which you can override:
 * + Results are sorted by `id` in descending order.
 * + `paging.offset` is `0`.
 *
 * For field support for filters and sorting, see [OAuth Apps: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-management/headless-authentication/oauth-apps/filters-sorting)
 *
 * To learn about working with _Query_ endpoints in general, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 */
export function queryOAuthApps(payload) {
    var _a = serializer(_queryOAuthAppsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryOAuthAppsResponse, {
        _oAuthApp: _oAuthApp,
    }).fromJSON;
    function __queryOAuthApps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.headless.v1.o_auth_app',
            method: 'POST',
            methodFqn: 'wix.headless.v1.OAuthAppService.QueryOAuthApps',
            url: resolveWixHeadlessV1OAuthAppServiceUrl({
                protoPath: '/v1/oauth-apps/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryOAuthApps.fromReq = fromReq;
    __queryOAuthApps.__isAmbassador = true;
    return __queryOAuthApps;
}
/**
 * Generates a secret for an existing OAuth app.
 *
 *
 * > **Note:** You can only generate a secret once for each OAuth app, and the secret can't be retrieved later. Store the secret securely.
 */
export function generateOAuthAppSecret(payload) {
    var _a = serializer(_generateOAuthAppSecretRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_generateOAuthAppSecretResponse, {}).fromJSON;
    function __generateOAuthAppSecret(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.headless.v1.o_auth_app',
            method: 'POST',
            methodFqn: 'wix.headless.v1.OAuthAppService.GenerateOAuthAppSecret',
            url: resolveWixHeadlessV1OAuthAppServiceUrl({
                protoPath: '/v1/oauth-apps/{oAuthAppId}/generate-secret',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __generateOAuthAppSecret.fromReq = fromReq;
    __generateOAuthAppSecret.__isAmbassador = true;
    return __generateOAuthAppSecret;
}
//# sourceMappingURL=http.impl.js.map